import React from 'react';

const JIRA_BASE_URL = process.env.REACT_APP_JIRA_BASE_URL || 'https://ischemaview.atlassian.net';

// Build a Jira "browse" URL for a ticket key (e.g. PM-1309 → .../browse/PM-1309).
export const jiraBrowseUrl = (key) => `${JIRA_BASE_URL}/browse/${encodeURIComponent(String(key || '').trim())}`;

/**
 * Renders a Jira ticket key (e.g. PM-1309) as a link that opens the ticket in
 * Jira in a new tab. Used anywhere in the SDLC flow that shows a linked ticket
 * key so users can jump straight to the ticket. Falls back to nothing when no
 * key is given; pass an explicit `href` to override the derived browse URL.
 */
const JiraTicketLink = ({ ticketKey, href, style, children }) => {
  const key = String(ticketKey || '').trim();
  if (!key) return null;
  return (
    <a
      href={href || jiraBrowseUrl(key)}
      target="_blank"
      rel="noopener noreferrer"
      title={`Open ${key} in Jira`}
      onClick={(e) => e.stopPropagation()}
      style={{ color: '#1a56db', textDecoration: 'none', ...style }}
    >
      {children || key}
    </a>
  );
};

export default JiraTicketLink;
